function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _toConsumableArray(r) { return _arrayWithoutHoles(r) || _iterableToArray(r) || _unsupportedIterableToArray(r) || _nonIterableSpread(); }
function _nonIterableSpread() { throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _iterableToArray(r) { if ("undefined" != typeof Symbol && null != r[Symbol.iterator] || null != r["@@iterator"]) return Array.from(r); }
function _arrayWithoutHoles(r) { if (Array.isArray(r)) return _arrayLikeToArray(r); }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
function _slicedToArray(r, e) { return _arrayWithHoles(r) || _iterableToArrayLimit(r, e) || _unsupportedIterableToArray(r, e) || _nonIterableRest(); }
function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(r, a) { if (r) { if ("string" == typeof r) return _arrayLikeToArray(r, a); var t = {}.toString.call(r).slice(8, -1); return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? _arrayLikeToArray(r, a) : void 0; } }
function _arrayLikeToArray(r, a) { (null == a || a > r.length) && (a = r.length); for (var e = 0, n = Array(a); e < a; e++) n[e] = r[e]; return n; }
function _iterableToArrayLimit(r, l) { var t = null == r ? null : "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"]; if (null != t) { var e, n, i, u, a = [], f = !0, o = !1; try { if (i = (t = t.call(r)).next, 0 === l) { if (Object(t) !== t) return; f = !1; } else for (; !(f = (e = i.call(t)).done) && (a.push(e.value), a.length !== l); f = !0); } catch (r) { o = !0, n = r; } finally { try { if (!f && null != t["return"] && (u = t["return"](), Object(u) !== u)) return; } finally { if (o) throw n; } } return a; } }
function _arrayWithHoles(r) { if (Array.isArray(r)) return r; }
import React, { useState, useEffect, useRef } from "react";
import { Container, Row, Col } from 'react-bootstrap';
import { Tabs, message, Skeleton, Button, Typography, Space, Select, Drawer, Descriptions, Upload, Input, Form, Modal, notification, DatePicker } from 'antd';
import { Table } from 'react-bootstrap';
import { CheckCircleFill, PrinterFill, CloudUpload, EyeFill, TrashFill, CreditCard2FrontFill, SearchHeart, ClockHistory, PieChartFill } from "react-bootstrap-icons";
import Common from "../components/includes/Common";
import Moment from "react-moment";
import Certificate from "../components/Certificate";
import ReactToPrint, { PrintContextConsumer } from 'react-to-print';
import Card from "../components/Card";
import moment from "moment";
import SendReport from "../components/SendReport";
import RefDocument from "../components/RefDocument";
import CertificateOld from "../components/CertificateOld";
import { jsx as _jsx, jsxs as _jsxs, Fragment as _Fragment } from "react/jsx-runtime";
var RangePicker = DatePicker.RangePicker;
var Text = Typography.Text,
  Link = Typography.Link;
var confirm = Modal.confirm;
var Certificates = function Certificates() {
  var _useState = useState(true),
    _useState2 = _slicedToArray(_useState, 2),
    isDataLoading = _useState2[0],
    setIsDataLoading = _useState2[1];
  var _useState3 = useState([]),
    _useState4 = _slicedToArray(_useState3, 2),
    compList = _useState4[0],
    setCompList = _useState4[1];
  var _useState5 = useState([{
      value: 0,
      label: "TOUTES"
    }]),
    _useState6 = _slicedToArray(_useState5, 2),
    compOptions = _useState6[0],
    setCompOptions = _useState6[1];
  var _useState7 = useState(null),
    _useState8 = _slicedToArray(_useState7, 2),
    companyId = _useState8[0],
    setCompanyId = _useState8[1];
  var _useState9 = useState(null),
    _useState0 = _slicedToArray(_useState9, 2),
    company = _useState0[0],
    setCompany = _useState0[1];
  var _useState1 = useState([]),
    _useState10 = _slicedToArray(_useState1, 2),
    customers = _useState10[0],
    setCustomers = _useState10[1];
  var _useState11 = useState(null),
    _useState12 = _slicedToArray(_useState11, 2),
    currentCustomer = _useState12[0],
    setCurrentCustomer = _useState12[1];
  var _useState13 = useState(false),
    _useState14 = _slicedToArray(_useState13, 2),
    showCertificate = _useState14[0],
    setShowCertificate = _useState14[1];
  var _useState15 = useState(false),
    _useState16 = _slicedToArray(_useState15, 2),
    dataChanged = _useState16[0],
    setDataChanged = _useState16[1];
  var _useState17 = useState(false),
    _useState18 = _slicedToArray(_useState17, 2),
    deleteProcessing = _useState18[0],
    setDeleteProcessing = _useState18[1];
  var _useState19 = useState(false),
    _useState20 = _slicedToArray(_useState19, 2),
    printProcessing = _useState20[0],
    setPrintProcessing = _useState20[1];
  var _useState21 = useState(false),
    _useState22 = _slicedToArray(_useState21, 2),
    showUpload = _useState22[0],
    setShowUpload = _useState22[1];
  var _useState23 = useState([]),
    _useState24 = _slicedToArray(_useState23, 2),
    file = _useState24[0],
    setFile = _useState24[1];
  var _useState25 = useState(""),
    _useState26 = _slicedToArray(_useState25, 2),
    fileErrorMessage = _useState26[0],
    setFileErrorMessage = _useState26[1];
  var _useState27 = useState(false),
    _useState28 = _slicedToArray(_useState27, 2),
    isFileFormProcessing = _useState28[0],
    setIsFileFormProcessing = _useState28[1];
  var _useState29 = useState(false),
    _useState30 = _slicedToArray(_useState29, 2),
    showCard = _useState30[0],
    setSHowCard = _useState30[1];
  var _useState31 = useState([]),
    _useState32 = _slicedToArray(_useState31, 2),
    historyCutsomers = _useState32[0],
    setHistoryCustomers = _useState32[1];
  var _useState33 = useState(null),
    _useState34 = _slicedToArray(_useState33, 2),
    hfrom = _useState34[0],
    setHfrom = _useState34[1];
  var _useState35 = useState(null),
    _useState36 = _slicedToArray(_useState35, 2),
    hto = _useState36[0],
    setHto = _useState36[1];
  var _useState37 = useState(false),
    _useState38 = _slicedToArray(_useState37, 2),
    isHistoryLoading = _useState38[0],
    setIsHistoryLoading = _useState38[1];
  var _useState39 = useState(false),
    _useState40 = _slicedToArray(_useState39, 2),
    showMreport = _useState40[0],
    setShowMreport = _useState40[1];
  var _useState41 = useState(false),
    _useState42 = _slicedToArray(_useState41, 2),
    showRefReport = _useState42[0],
    setShowRefReport = _useState42[1];
  var _Form$useForm = Form.useForm(),
    _Form$useForm2 = _slicedToArray(_Form$useForm, 1),
    form = _Form$useForm2[0];
  var _Form$useForm3 = Form.useForm(),
    _Form$useForm4 = _slicedToArray(_Form$useForm3, 1),
    hform = _Form$useForm4[0];
  var ref = useRef();
  var _useState43 = useState(20),
    _useState44 = _slicedToArray(_useState43, 2),
    limit = _useState44[0],
    setLimit = _useState44[1];
  var _useState45 = useState(0),
    _useState46 = _slicedToArray(_useState45, 2),
    offset = _useState46[0],
    setOffset = _useState46[1];
  var _useState47 = useState("0"),
    _useState48 = _slicedToArray(_useState47, 2),
    keyword = _useState48[0],
    setKeyword = _useState48[1];
  var props = {
    onRemove: function onRemove(file) {
      setFile(null);
    },
    beforeUpload: function beforeUpload(file) {
      setFile(file);
      return false;
    },
    accept: ".pdf",
    maxCount: 1
  };
  var handleKewordChange = function handleKewordChange(v) {
    setKeyword(v.target.value);
  };
  var handleMore = function handleMore() {
    setLimit(function (prev) {
      return prev + 20;
    });
  };
  var handleCompanyChange = function handleCompanyChange(v) {
    if (compList.filter(function (c) {
      return c.id == v;
    }).length > 0) {
      setCompany(compList.filter(function (c) {
        return c.id == v;
      })[0]);
      setCompanyId(compList.filter(function (c) {
        return c.id == v;
      })[0].id);
      localStorage.setItem("defaultCompany", compList.filter(function (c) {
        return c.id == v;
      })[0].id);
    } else {
      setCompany(null);
      setCompanyId(0);
      localStorage.setItem("defaultCompany", 0);
    }
  };
  var handleSearchHistory = function handleSearchHistory(values) {
    setIsHistoryLoading(true);
    axios.post("".concat(Common.baseApiUrl, "getconclusioncustomers"), {
      company_id: values.company_id,
      user_id: Common.currentUser.id,
      limit: moment(values.period[0].$d).format(),
      offset: moment(values.period[1].$d).format(),
      candidate_code: ''
    }).then(function (response) {
      setHistoryCustomers(response.data.customers);
    })["catch"](function (error) {
      message.error({
        content: "Une erreur est survenue",
        delay: 4
      });
    })["finally"](function () {
      setIsHistoryLoading(false);
    });
  };
  var items = [{
    label: /*#__PURE__*/_jsxs("b", {
      children: [/*#__PURE__*/_jsx(PrinterFill, {
        size: 24
      }), " Attente d'impress."]
    }),
    key: 1,
    children: /*#__PURE__*/_jsxs(_Fragment, {
      children: [/*#__PURE__*/_jsxs(Table, {
        striped: true,
        bordered: true,
        hover: true,
        responsive: true,
        children: [/*#__PURE__*/_jsx("thead", {
          children: /*#__PURE__*/_jsxs("tr", {
            children: [/*#__PURE__*/_jsx("th", {
              children: "A/I"
            }), /*#__PURE__*/_jsx("th", {
              children: "CODE"
            }), /*#__PURE__*/_jsx("th", {
              children: "NOM"
            }), /*#__PURE__*/_jsx("th", {
              children: "SOCIETE"
            }), /*#__PURE__*/_jsx("th", {})]
          })
        }), /*#__PURE__*/_jsx("tbody", {
          children: customers.filter(function (c) {
            return c.conclusion != null && c.status == 2;
          }).map(function (c) {
            return /*#__PURE__*/_jsxs("tr", {
              children: [/*#__PURE__*/_jsx("td", {
                children: c.conclusion.conclusion == 1 || c.conclusion.conclusion == 2 || c.conclusion.conclusion == 3 || c.conclusion.conclusion == 7 || c.conclusion.conclusion == 8 || c.conclusion.conclusion == 9 || c.conclusion.conclusion == 10 || c.conclusion.conclusion == 11 ? /*#__PURE__*/_jsx("div", {
                  children: "A"
                }) : /*#__PURE__*/_jsx("div", {
                  children: "I"
                })
              }), /*#__PURE__*/_jsx("td", {
                children: c.candidate_code
              }), /*#__PURE__*/_jsx("td", {
                children: c.name
              }), /*#__PURE__*/_jsx("td", {
                children: c.company.label
              }), /*#__PURE__*/_jsx("td", {
                children: /*#__PURE__*/_jsx(Space, {
                  direction: "horizontal",
                  children: /*#__PURE__*/_jsx(Button, {
                    disabled: c.conclusion == null,
                    type: "link",
                    size: "small",
                    onClick: function onClick() {
                      setCurrentCustomer(c);
                      setShowCertificate(true);
                    },
                    children: /*#__PURE__*/_jsx("b", {
                      children: /*#__PURE__*/_jsx(EyeFill, {
                        size: 24
                      })
                    })
                  })
                })
              })]
            }, c.id);
          })
        })]
      }), isDataLoading == true && /*#__PURE__*/_jsx(Skeleton, {
        active: true
      })]
    })
  }, {
    label: /*#__PURE__*/_jsxs("b", {
      children: [/*#__PURE__*/_jsx(CloudUpload, {
        size: 24
      }), " En attente de chargem."]
    }),
    key: 2,
    children: /*#__PURE__*/_jsxs(_Fragment, {
      children: [/*#__PURE__*/_jsxs(Table, {
        striped: true,
        bordered: true,
        hover: true,
        responsive: true,
        children: [/*#__PURE__*/_jsx("thead", {
          children: /*#__PURE__*/_jsxs("tr", {
            children: [/*#__PURE__*/_jsx("th", {
              children: "CODE"
            }), /*#__PURE__*/_jsx("th", {
              children: "NOM"
            }), /*#__PURE__*/_jsx("th", {
              children: "SOCIETE"
            }), /*#__PURE__*/_jsx("th", {
              children: "ACTION"
            })]
          })
        }), /*#__PURE__*/_jsx("tbody", {
          children: customers.filter(function (c) {
            return c.conclusion != null && c.status == 1;
          }).map(function (c) {
            return /*#__PURE__*/_jsxs("tr", {
              children: [/*#__PURE__*/_jsx("td", {
                children: c.candidate_code
              }), /*#__PURE__*/_jsx("td", {
                children: c.name
              }), /*#__PURE__*/_jsx("td", {
                children: c.company.label
              }), /*#__PURE__*/_jsx("td", {
                children: /*#__PURE__*/_jsxs(Space, {
                  direction: "horizontal",
                  children: [/*#__PURE__*/_jsx(Button, {
                    type: "link",
                    disabled: c.conclusion == null,
                    size: "small",
                    onClick: function onClick() {
                      setCurrentCustomer(c);
                      setShowUpload(true);
                    },
                    children: /*#__PURE__*/_jsx("b", {
                      children: "CHARGER"
                    })
                  }), /*#__PURE__*/_jsx(Button, {
                    type: "link",
                    disabled: c.conclusion == null,
                    size: "small",
                    onClick: function onClick() {
                      setCurrentCustomer(c);
                      setShowCertificate(true);
                    },
                    children: /*#__PURE__*/_jsx("b", {
                      children: /*#__PURE__*/_jsx(EyeFill, {
                        size: 24
                      })
                    })
                  })]
                })
              })]
            }, c.id);
          })
        })]
      }), isDataLoading == true && /*#__PURE__*/_jsx(Skeleton, {
        active: true
      })]
    })
  }, {
    label: /*#__PURE__*/_jsxs("b", {
      children: [/*#__PURE__*/_jsx(CheckCircleFill, {
        size: 24
      }), " Trait\xE9s"]
    }),
    key: 3,
    children: /*#__PURE__*/_jsxs(_Fragment, {
      children: [/*#__PURE__*/_jsxs(Table, {
        striped: true,
        bordered: true,
        hover: true,
        responsive: true,
        children: [/*#__PURE__*/_jsx("thead", {
          children: /*#__PURE__*/_jsxs("tr", {
            children: [/*#__PURE__*/_jsx("th", {
              children: "A/I"
            }), /*#__PURE__*/_jsx("th", {
              children: "CODE"
            }), /*#__PURE__*/_jsx("th", {
              children: "NOM"
            }), /*#__PURE__*/_jsx("th", {
              children: "SOCIETE"
            }), /*#__PURE__*/_jsx("th", {})]
          })
        }), /*#__PURE__*/_jsx("tbody", {
          children: customers.filter(function (c) {
            return c.conclusion != null && c.conclusion.printed == 1 && c.conclusion.file != null;
          }).map(function (c) {
            return /*#__PURE__*/_jsxs("tr", {
              children: [/*#__PURE__*/_jsx("td", {
                children: c.conclusion.conclusion == 1 || c.conclusion.conclusion == 2 || c.conclusion.conclusion == 3 || c.conclusion.conclusion == 7 || c.conclusion.conclusion == 8 || c.conclusion.conclusion == 9 || c.conclusion.conclusion == 10 || c.conclusion.conclusion == 11 ? /*#__PURE__*/_jsx("div", {
                  children: "A"
                }) : /*#__PURE__*/_jsx("div", {
                  children: "I"
                })
              }), /*#__PURE__*/_jsx("td", {
                children: c.candidate_code
              }), /*#__PURE__*/_jsx("td", {
                children: c.name
              }), /*#__PURE__*/_jsx("td", {
                children: c.company.label
              }), /*#__PURE__*/_jsxs("td", {
                children: [/*#__PURE__*/_jsx(Button, {
                  type: "link",
                  disabled: c.conclusion == null,
                  size: "small",
                  onClick: function onClick() {
                    setCurrentCustomer(c);
                    setShowCertificate(true);
                  },
                  children: /*#__PURE__*/_jsx("b", {
                    children: /*#__PURE__*/_jsx(EyeFill, {
                      size: 24
                    })
                  })
                }), /*#__PURE__*/_jsx(Button, {
                  loading: deleteProcessing,
                  disabled: c.conclusion == null,
                  type: "link",
                  size: "small",
                  onClick: function onClick() {
                    setCurrentCustomer(c);
                    confirm({
                      title: /*#__PURE__*/_jsx("p", {
                        children: "Confirmez-vous ?"
                      }),
                      content: /*#__PURE__*/_jsxs("p", {
                        children: ["La suppression du certificat (version scann\xE9) pour ", c.name, " ?"]
                      }),
                      onOk: function onOk() {
                        setDeleteProcessing(true);
                        axios.post(Common.baseApiUrl + "deleteloadedcertificate", {
                          user_id: Common.currentUser.id,
                          conclusion_id: c.conclusion.id.toString()
                        }).then(function (response) {
                          if (response.data.status == 200) {
                            setDataChanged(true);
                            notification.success(_defineProperty({
                              message: "Ok!"
                            }, "message", response.data.message));
                          } else {
                            notification.error({
                              message: "Erreur",
                              description: response.data.response
                            });
                          }
                        })["catch"](function (error) {
                          notification.error({
                            message: "Erreur",
                            description: "Une erreur est survenue " + error.toString()
                          });
                        })["finally"](function () {
                          setDeleteProcessing(false);
                        });
                      }
                    });
                  },
                  children: /*#__PURE__*/_jsx("b", {
                    children: /*#__PURE__*/_jsx(TrashFill, {
                      size: 24
                    })
                  })
                })]
              })]
            }, c.id);
          })
        })]
      }), isDataLoading == true && /*#__PURE__*/_jsx(Skeleton, {
        active: true
      })]
    })
  }, {
    label: /*#__PURE__*/_jsxs("b", {
      children: [/*#__PURE__*/_jsx(ClockHistory, {
        size: 24
      }), " Inaptes temp."]
    }),
    key: "t4",
    children: /*#__PURE__*/_jsxs(_Fragment, {
      children: [/*#__PURE__*/_jsxs(Table, {
        striped: true,
        bordered: true,
        hover: true,
        responsive: true,
        children: [/*#__PURE__*/_jsx("thead", {
          children: /*#__PURE__*/_jsxs("tr", {
            children: [/*#__PURE__*/_jsx("th", {
              children: "Date"
            }), /*#__PURE__*/_jsx("th", {
              children: "A/I"
            }), /*#__PURE__*/_jsx("th", {
              children: "CODE"
            }), /*#__PURE__*/_jsx("th", {
              children: "NOM"
            }), /*#__PURE__*/_jsx("th", {
              children: "SOCIETE"
            }), /*#__PURE__*/_jsx("th", {})]
          })
        }), /*#__PURE__*/_jsx("tbody", {
          children: customers.filter(function (c) {
            return c.conclusion != null && c.status == 2;
          }).map(function (c) {
            return /*#__PURE__*/_jsxs("tr", {
              children: [/*#__PURE__*/_jsx("td", {
                style: {
                  color: c.nationality.toLowerCase().indexOf("guin") > -1 && c.nationality.split(" ").length == 1 ? '#000000' : '#965435'
                },
                children: c.conclusion.conclusion == 1 || c.conclusion.conclusion == 2 || c.conclusion.conclusion == 3 || c.conclusion.conclusion == 7 || c.conclusion.conclusion == 8 || c.conclusion.conclusion == 9 || c.conclusion.conclusion == 10 || c.conclusion.conclusion == 11 ? /*#__PURE__*/_jsx("div", {
                  children: "A"
                }) : /*#__PURE__*/_jsx("div", {
                  children: "I"
                })
              }), /*#__PURE__*/_jsx("td", {
                style: {
                  color: c.nationality.toLowerCase().indexOf("guin") > -1 && c.nationality.split(" ").length == 1 ? '#000000' : '#965435'
                },
                children: c.candidate_code
              }), /*#__PURE__*/_jsx("td", {
                style: {
                  color: c.nationality.toLowerCase().indexOf("guin") > -1 && c.nationality.split(" ").length == 1 ? '#000000' : '#965435'
                },
                children: c.name
              }), /*#__PURE__*/_jsx("td", {
                style: {
                  color: c.nationality.toLowerCase().indexOf("guin") > -1 && c.nationality.split(" ").length == 1 ? '#000000' : '#965435'
                },
                children: c.company.label
              }), /*#__PURE__*/_jsx("td", {
                style: {
                  color: c.nationality.toLowerCase().indexOf("guin") > -1 && c.nationality.split(" ").length == 1 ? '#000000' : '#965435'
                },
                children: /*#__PURE__*/_jsxs(Space, {
                  direction: "horizontal",
                  children: [/*#__PURE__*/_jsx(Button, {
                    type: "primary",
                    size: "small",
                    onClick: function onClick() {
                      setCurrentCustomer(c);
                      setShowMreport(true);
                    },
                    children: /*#__PURE__*/_jsx("b", {
                      children: "R. MEDICAL"
                    })
                  }), /*#__PURE__*/_jsx(Button, {
                    type: "primary",
                    size: "small",
                    onClick: function onClick() {
                      setCurrentCustomer(c);
                      setShowRefReport(true);
                    },
                    children: /*#__PURE__*/_jsx("b", {
                      children: /*#__PURE__*/_jsx(EyeFill, {
                        size: 24
                      })
                    })
                  })]
                })
              })]
            }, c.id);
          })
        })]
      }), isDataLoading == true && /*#__PURE__*/_jsx(Skeleton, {
        active: true
      })]
    })
  }, {
    label: /*#__PURE__*/_jsxs("b", {
      children: [/*#__PURE__*/_jsx(ClockHistory, {
        size: 24
      }), " Historique"]
    }),
    key: 4,
    children: /*#__PURE__*/_jsxs(_Fragment, {
      children: [/*#__PURE__*/_jsx(Row, {
        children: /*#__PURE__*/_jsx(Col, {
          lg: 12,
          md: 12,
          children: /*#__PURE__*/_jsx("div", {
            style: {
              padding: "14px",
              borderRadius: "6px",
              background: "#FFFFFF"
            },
            children: /*#__PURE__*/_jsx(Form, {
              form: hform,
              onFinish: handleSearchHistory,
              children: /*#__PURE__*/_jsxs(Space, {
                direction: "horizontal",
                children: [/*#__PURE__*/_jsx(Form.Item, {
                  name: "company_id",
                  children: /*#__PURE__*/_jsx(Select, {
                    options: compOptions,
                    style: {
                      width: "200px"
                    }
                  })
                }), /*#__PURE__*/_jsx(Form.Item, {
                  name: "period",
                  rules: [{
                    required: true,
                    message: "Veuillez choisir une période"
                  }],
                  children: /*#__PURE__*/_jsx(RangePicker, {})
                }), /*#__PURE__*/_jsx(Form.Item, {
                  children: /*#__PURE__*/_jsx(Button, {
                    loading: isHistoryLoading,
                    type: "primary",
                    htmlType: "submit",
                    children: /*#__PURE__*/_jsxs("b", {
                      children: [/*#__PURE__*/_jsx(SearchHeart, {
                        size: 20
                      }), " CHERCHER"]
                    })
                  })
                })]
              })
            })
          })
        })
      }), /*#__PURE__*/_jsx("br", {}), /*#__PURE__*/_jsxs(Table, {
        striped: true,
        bordered: true,
        hover: true,
        responsive: true,
        children: [/*#__PURE__*/_jsx("thead", {
          children: /*#__PURE__*/_jsxs("tr", {
            children: [/*#__PURE__*/_jsx("th", {
              children: "Date"
            }), /*#__PURE__*/_jsx("th", {
              children: "A/I"
            }), /*#__PURE__*/_jsx("th", {
              children: "CODE"
            }), /*#__PURE__*/_jsx("th", {
              children: "NOM"
            }), /*#__PURE__*/_jsx("th", {
              children: "SOCIETE"
            }), /*#__PURE__*/_jsx("th", {})]
          })
        }), /*#__PURE__*/_jsx("tbody", {
          children: historyCutsomers.filter(function (c) {
            return c.status == 1;
          }).map(function (c) {
            return /*#__PURE__*/_jsxs("tr", {
              children: [/*#__PURE__*/_jsx("td", {
                children: /*#__PURE__*/_jsx(Moment, {
                  date: c.created_at,
                  format: "DD/MM/YYYY"
                })
              }), /*#__PURE__*/_jsx("td", {
                children: c.conclusion.conclusion == 1 || c.conclusion.conclusion == 2 || c.conclusion.conclusion == 3 || c.conclusion.conclusion == 7 || c.conclusion.conclusion == 8 || c.conclusion.conclusion == 9 || c.conclusion.conclusion == 10 || c.conclusion.conclusion == 11 ? /*#__PURE__*/_jsx("div", {
                  children: "A"
                }) : /*#__PURE__*/_jsx("div", {
                  children: "I"
                })
              }), /*#__PURE__*/_jsx("td", {
                children: c.candidate_code
              }), /*#__PURE__*/_jsx("td", {
                children: c.name
              }), /*#__PURE__*/_jsx("td", {
                children: c.company.label
              }), /*#__PURE__*/_jsx("td", {
                children: /*#__PURE__*/_jsx(Button, {
                  type: "link",
                  disabled: c.conclusion == null,
                  size: "small",
                  onClick: function onClick() {
                    setCurrentCustomer(c);
                    setShowCertificate(true);
                  },
                  children: /*#__PURE__*/_jsx("b", {
                    children: /*#__PURE__*/_jsx(EyeFill, {
                      size: 24
                    })
                  })
                })
              })]
            }, c.id);
          })
        })]
      }), isDataLoading == true && /*#__PURE__*/_jsx(Skeleton, {
        active: true
      })]
    })
  }, {
    key: 5,
    label: /*#__PURE__*/_jsxs("b", {
      children: [/*#__PURE__*/_jsx(PieChartFill, {
        size: 22
      }), " RAPPORT"]
    }),
    children: /*#__PURE__*/_jsx(_Fragment, {
      children: /*#__PURE__*/_jsx(SendReport, {
        companies: compOptions
      })
    })
  }, {
    label: /*#__PURE__*/_jsxs("b", {
      children: [/*#__PURE__*/_jsx(CreditCard2FrontFill, {
        size: 24
      }), " Cartes de sant\xE9"]
    }),
    key: 6,
    children: /*#__PURE__*/_jsxs(_Fragment, {
      children: [/*#__PURE__*/_jsxs(Table, {
        striped: true,
        bordered: true,
        hover: true,
        responsive: true,
        children: [/*#__PURE__*/_jsx("thead", {
          children: /*#__PURE__*/_jsxs("tr", {
            children: [/*#__PURE__*/_jsx("th", {
              children: "CODE"
            }), /*#__PURE__*/_jsx("th", {
              children: "NOM"
            }), /*#__PURE__*/_jsx("th", {
              children: "SOCIETE"
            }), /*#__PURE__*/_jsx("th", {})]
          })
        }), /*#__PURE__*/_jsx("tbody", {
          children: customers.map(function (c) {
            return /*#__PURE__*/_jsxs("tr", {
              children: [/*#__PURE__*/_jsx("td", {
                children: c.candidate_code
              }), /*#__PURE__*/_jsx("td", {
                children: c.name
              }), /*#__PURE__*/_jsx("td", {
                children: c.company.label
              }), /*#__PURE__*/_jsx("td", {
                children: /*#__PURE__*/_jsx(Button, {
                  type: "link",
                  size: "small",
                  onClick: function onClick() {
                    setCurrentCustomer(c);
                    setSHowCard(true);
                  },
                  children: /*#__PURE__*/_jsx("b", {
                    children: /*#__PURE__*/_jsx(CreditCard2FrontFill, {
                      size: 24
                    })
                  })
                })
              })]
            }, c.id);
          })
        })]
      }), isDataLoading == true && /*#__PURE__*/_jsx(Skeleton, {
        active: true
      })]
    })
  }];
  var loadData = function loadData(cid) {
    setIsDataLoading(true);
    if (cid == null) return;
    axios.post("".concat(Common.baseApiUrl, "getcompanycerts"), {
      company_id: cid,
      user_id: Common.currentUser.id,
      limit: limit,
      offset: offset,
      keyword: keyword
    }).then(function (response) {
      setCustomers(response.data.customers);
    })["catch"](function (error) {
      message.error({
        content: "Une erreur est survenue " + error.toString(),
        delay: 4
      });
    })["finally"](function () {
      setIsDataLoading(false);
    });
  };
  useEffect(function () {
    setIsDataLoading(true);
    axios.get(Common.baseApiUrl + 'getcompanylist').then(function (response) {
      if (response.data.status == 200) {
        setCompOptions([{
          value: 0,
          label: "TOUTES"
        }]);
        response.data.companyList.forEach(function (c) {
          setCompOptions(function (prev) {
            return [].concat(_toConsumableArray(prev), [{
              value: c.id,
              label: c.label
            }]);
          });
        });
        setCompList(response.data.companyList);
        //setCompanyId(response.data.companyList[0].id);     
        setCompanyId(0);
        //setCompany(response.data.companyList[0]);
        setCompany(null);
        //loadData(response.data.companyList[0].id);        
        if (response.data.companyList.length > 0) {
          if (localStorage.getItem("defaultCompany") != null && localStorage.getItem("defaultCompany") != 'undefined') {
            form.setFieldsValue({
              comp: parseInt(localStorage.getItem("defaultCompany"))
            });
          } else {
            form.setFieldsValue({
              comp: response.data.companyList[0].id
            });
            localStorage.setItem("defaultCompany", response.data.companyList[0].id);
          }
        }
        loadData(localStorage.getItem("defaultCompany"));
      } else {
        message.error({
          content: 'Une erreur est survenue ' + error.toString(),
          delay: 4
        });
      }
    })["catch"](function (error) {
      message.error({
        content: 'Une erreur est survenue ' + error.toString(),
        delay: 4
      });
    })["finally"](function () {
      setIsDataLoading(false);
    });
  }, []);
  useEffect(function () {
    loadData(companyId);
  }, [companyId, dataChanged, limit, keyword, offset]);
  return /*#__PURE__*/_jsxs(_Fragment, {
    children: [/*#__PURE__*/_jsxs(Container, {
      children: [/*#__PURE__*/_jsx(Row, {
        children: /*#__PURE__*/_jsxs(Col, {
          children: [/*#__PURE__*/_jsx(Text, {
            mark: true,
            children: /*#__PURE__*/_jsx("b", {
              children: "#CERTIFICATS"
            })
          }), /*#__PURE__*/_jsx("br", {}), /*#__PURE__*/_jsx("br", {})]
        })
      }), /*#__PURE__*/_jsx(Row, {
        children: /*#__PURE__*/_jsxs(Col, {
          lg: 12,
          md: 12,
          children: [/*#__PURE__*/_jsx(Form, {
            form: form,
            children: /*#__PURE__*/_jsxs(Space, {
              direction: "horizontal",
              children: [/*#__PURE__*/_jsx(Form.Item, {
                name: "comp",
                children: /*#__PURE__*/_jsx(Select, {
                  showSearch: true,
                  optionLabelProp: "label",
                  optionFilterProp: "label",
                  filterOption: function filterOption(input, option) {
                    return option.label.toLowerCase().includes(input.toLowerCase());
                  },
                  options: compOptions,
                  onChange: handleCompanyChange,
                  style: {
                    width: "200px"
                  }
                })
              }), /*#__PURE__*/_jsx(Form.Item, {
                children: /*#__PURE__*/_jsx(Input, {
                  onChange: handleKewordChange,
                  placeholder: "Code dossier"
                })
              })]
            })
          }), /*#__PURE__*/_jsx(Tabs, {
            items: items,
            animated: true,
            defaultActiveKey: 1
          }), /*#__PURE__*/_jsx("br", {}), /*#__PURE__*/_jsx("div", {
            style: {
              textAlign: "center"
            },
            children: /*#__PURE__*/_jsx(Button, {
              loading: isDataLoading,
              type: "default",
              onClick: handleMore,
              children: /*#__PURE__*/_jsx("b", {
                children: "VOIR PLUS"
              })
            })
          })]
        })
      })]
    }), currentCustomer && /*#__PURE__*/_jsxs(_Fragment, {
      children: [/*#__PURE__*/_jsx(Drawer, {
        open: showCertificate,
        title: /*#__PURE__*/_jsx("b", {
          children: "CERTIFICAT D'APTITUDE/REF"
        }),
        width: "80%",
        onClose: function onClose() {
          setShowCertificate(false);
        },
        extra: [/*#__PURE__*/_jsx(ReactToPrint, {
          content: function content() {
            return ref.current;
          },
          children: /*#__PURE__*/_jsx(PrintContextConsumer, {
            children: function children(_ref) {
              var handlePrint = _ref.handlePrint;
              return /*#__PURE__*/_jsx(Button, {
                loading: printProcessing,
                type: "primary",
                onClick: function onClick() {
                  setPrintProcessing(true);
                  axios.post(Common.baseApiUrl + "setcertificateprinted", {
                    user_id: Common.currentUser.id,
                    customer_id: currentCustomer.id.toString()
                  }).then(function (response) {
                    if (response.data.status == 200) {
                      setDataChanged(true);
                      handlePrint();
                    } else notification.error({
                      message: "Erreur",
                      description: response.data.message
                    });
                  })["catch"](function (error) {
                    notification.error({
                      message: "Erreur",
                      description: "Une erreur est survenue lors de l'impression " + error.toString()
                    });
                  })["finally"](function () {
                    setPrintProcessing(false);
                  });
                },
                children: /*#__PURE__*/_jsx("b", {
                  children: "IMPRIMER"
                })
              });
            }
          })
        })],
        destroyOnClose: true,
        children: currentCustomer.company_id != 151 ? /*#__PURE__*/_jsx(Certificate, {
          ref: ref,
          candidat: currentCustomer
        }) : /*#__PURE__*/_jsx(CertificateOld, {
          ref: ref,
          candidat: currentCustomer
        })
      }), /*#__PURE__*/_jsx(Drawer, {
        open: showRefReport,
        title: /*#__PURE__*/_jsx("b", {
          children: "FICHE REFERENCES"
        }),
        width: "80%",
        onClose: function onClose() {
          setShowRefReport(false);
        },
        extra: [/*#__PURE__*/_jsx(ReactToPrint, {
          content: function content() {
            return ref.current;
          },
          children: /*#__PURE__*/_jsx(PrintContextConsumer, {
            children: function children(_ref2) {
              var handlePrint = _ref2.handlePrint;
              return /*#__PURE__*/_jsx(Button, {
                type: "primary",
                onClick: handlePrint,
                children: /*#__PURE__*/_jsxs("b", {
                  children: [/*#__PURE__*/_jsx(PrinterFill, {
                    size: 18
                  }), " IMPRIMER"]
                })
              });
            }
          })
        })],
        destroyOnClose: true,
        children: /*#__PURE__*/_jsx(RefDocument, {
          ref: ref,
          candidat: currentCustomer
        })
      }), /*#__PURE__*/_jsx(Drawer, {
        open: showUpload,
        title: /*#__PURE__*/_jsx("b", {
          children: "JOINDRE LE CERTIFICAT"
        }),
        width: "400px",
        onClose: function onClose() {
          setShowUpload(false);
        },
        destroyOnClose: true,
        children: /*#__PURE__*/_jsxs("div", {
          style: {
            padding: "10px",
            background: "#FFDE59"
          },
          children: [/*#__PURE__*/_jsxs(Descriptions, {
            column: 1,
            children: [/*#__PURE__*/_jsx(Descriptions.Item, {
              label: /*#__PURE__*/_jsx("b", {
                children: "N.DOSSIER"
              }),
              children: currentCustomer.candidate_code
            }), /*#__PURE__*/_jsx(Descriptions.Item, {
              label: /*#__PURE__*/_jsx("b", {
                children: "MATRICULE"
              }),
              children: currentCustomer.matricule
            }), /*#__PURE__*/_jsx(Descriptions.Item, {
              label: /*#__PURE__*/_jsx("b", {
                children: "NOM"
              }),
              children: currentCustomer.name
            }), /*#__PURE__*/_jsx(Descriptions.Item, {
              label: /*#__PURE__*/_jsx("b", {
                children: "POSTE"
              }),
              children: currentCustomer.job
            })]
          }), /*#__PURE__*/_jsx("br", {}), /*#__PURE__*/_jsx("br", {}), /*#__PURE__*/_jsx("br", {}), /*#__PURE__*/_jsx("div", {
            children: /*#__PURE__*/_jsxs(Form, {
              direction: "vertical",
              onFinish: function onFinish(values) {
                setFileErrorMessage('');
                setIsFileFormProcessing(true);
                var formData = new FormData();
                formData.append("user_id", Common.currentUser.id);
                formData.append("customer_id", currentCustomer.id.toString());
                formData.append("file", file);
                setIsFileFormProcessing(true);
                axios.post(Common.baseApiUrl + "setcertificate", formData).then(function (response) {
                  if (response.data.status == 200) {
                    setShowUpload(false);
                    notification.success({
                      message: "Ok !",
                      description: "Opération éffectuée"
                    });
                  } else {
                    setFileErrorMessage(response.data.message);
                  }
                })["catch"](function (error) {
                  setFileErrorMessage("Une erreur est survenue " + error.toString());
                })["finally"](function () {
                  setIsFileFormProcessing(false);
                });
              },
              children: [/*#__PURE__*/_jsx(Form.Item, {
                name: "file",
                children: /*#__PURE__*/_jsx(Upload, _objectSpread(_objectSpread({}, props), {}, {
                  children: /*#__PURE__*/_jsx(Button, {
                    type: "default",
                    children: /*#__PURE__*/_jsx("b", {
                      children: "CHARGER LE FICHIER"
                    })
                  })
                }))
              }), /*#__PURE__*/_jsx(Form.Item, {
                children: /*#__PURE__*/_jsx(Button, {
                  loading: isFileFormProcessing,
                  type: "primary",
                  htmlType: "submit",
                  children: /*#__PURE__*/_jsx("b", {
                    children: "ENVOYER"
                  })
                })
              })]
            })
          })]
        })
      }), /*#__PURE__*/_jsx(Drawer, {
        title: /*#__PURE__*/_jsx("b", {
          children: "CARTE VITALE"
        }),
        width: "60%",
        open: showCard,
        extra: /*#__PURE__*/_jsx(Space, {
          children: /*#__PURE__*/_jsx(ReactToPrint, {
            content: function content() {
              return ref.current;
            },
            children: /*#__PURE__*/_jsx(PrintContextConsumer, {
              children: function children(_ref3) {
                var handlePrint = _ref3.handlePrint;
                return /*#__PURE__*/_jsx(Button, {
                  size: "large",
                  type: "primary",
                  onClick: handlePrint,
                  children: /*#__PURE__*/_jsxs("b", {
                    children: [/*#__PURE__*/_jsx(PrinterFill, {
                      size: 22
                    }), " IMPRIMER"]
                  })
                });
              }
            })
          })
        }),
        onClose: function onClose() {
          setSHowCard(false);
        },
        destroyOnClose: true,
        children: /*#__PURE__*/_jsx(Card, {
          ref: ref,
          candidat: currentCustomer
        })
      }), /*#__PURE__*/_jsx(Drawer, {
        open: showRefReport,
        title: /*#__PURE__*/_jsx("b", {
          children: "FICHE REFERENCES"
        }),
        width: "80%",
        onClose: function onClose() {
          setShowRefReport(false);
        },
        extra: [/*#__PURE__*/_jsx(ReactToPrint, {
          content: function content() {
            return ref.current;
          },
          children: /*#__PURE__*/_jsx(PrintContextConsumer, {
            children: function children(_ref4) {
              var handlePrint = _ref4.handlePrint;
              return /*#__PURE__*/_jsx(Button, {
                type: "primary",
                onClick: handlePrint,
                children: /*#__PURE__*/_jsxs("b", {
                  children: [/*#__PURE__*/_jsx(PrinterFill, {
                    size: 18
                  }), " IMPRIMER"]
                })
              });
            }
          })
        })],
        destroyOnClose: true,
        children: /*#__PURE__*/_jsx(RefDocument, {
          ref: ref,
          candidat: currentCustomer
        })
      })]
    })]
  });
};
export default Certificates;